import { Injectable } from '@angular/core';

import { map, Observable, of } from 'rxjs';

import { UsawMembership } from '@reg/shared/model';
import { HttpServiceHelper } from '@reg/shared/service/http-service-helper';
import { IJsonApiResponse } from '../json-api/json-api.interface';
import { observableInSeparateThread } from '../helper/observable-helper';

/**
 * Service to get usawMemberships
 */
@Injectable()
export class UsawMembershipService {
    private cachedUsawMemberships: UsawMembership[] = null;

    constructor(private http: HttpServiceHelper) {
    }

    /**
     * Get all usawMemberships
     */
    public getIndex(forceRefresh: boolean = false): Observable<UsawMembership[]> {
        if (!forceRefresh &&
            this.cachedUsawMemberships) {
            // if `cachedUsawMemberships` is available just return it as `Observable`
            return observableInSeparateThread(this.cachedUsawMemberships);
        }
        // Make the http request
        const apiUrl: string = `${this.http.configService.getApiBaseUrl()}/usaw-memberships/`;

        return this.http.get(apiUrl)
            .pipe(map((response: IJsonApiResponse) => {
                const usawMemberships: UsawMembership[] = [];
                const bodyData: any = response.data || [];
                for (const usawMembership of bodyData) {
                    usawMemberships.push((new UsawMembership()).deserialize(usawMembership));
                }
                this.cachedUsawMemberships = usawMemberships;
                return this.cachedUsawMemberships;
            }));
    }
}
